import Cookies from 'js-cookie'
/**
 * 获取 url 中的参数
 */
export const getParams = function (name, url) {
  const str = url || window.location.href
  let paramsMap = {}
  const index = str.lastIndexOf('?')
  if (index === -1) {
    // 没有参数
    return paramsMap
  }
  const paramStr = str.substring(index + 1, str.length)
  if (!paramStr) {
    // 参数为空
    return paramsMap
  }
  const pairs = paramStr.split('&')
  paramsMap = pairs.map(pair => {
    const [key, value] = pair.split('=')
    return [decodeURIComponent(key), decodeURIComponent(value)]
  }).reduce((res, [key, value]) => Object.assign(res, { [key]: value }), {})
  return name ? paramsMap[name] || '' : paramsMap
}

/**
 * 保存 url 中所有参数到 cookies
 * @param {*} obj url 中获取
 */
export const setAutograph = function (obj) {
  for (const [key, value] of Object.entries(obj)) {
    value && Cookies.set(key, value)
  }
}
